import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../../common/BaseComponent';
import { UserRoleDetails } from 'src/app/model/userRoleDetails';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AdminService } from 'src/app/service/admin/AdminService';
import { ProgressService } from 'src/app/service/ProgressService';

@Component({
  selector: 'app-admin-confirm-req',
  templateUrl: './admin-confirm-req.component.html',
  styles: [
  ]
})
export class AdminConfirmReqComponent extends BaseComponent implements OnInit {
  @ViewChild('progressDialog') progressDialogElementRef!: ElementRef<HTMLDialogElement>;

  restSub: Subscription;
  appErrorPrefix: string = "bss.api.error";
  userRoleDetails: UserRoleDetails;
  operationDescription: any;
  emailChecked: boolean = false;
  operationKey:string;
  roleAssignmentEmail: number;


  constructor(
    injector: Injector,
    private translate: TranslateService,
    public progressService: ProgressService,
    public rest: AdminService,) {
    super(injector);
  }

  ngOnInit(): void {

    const sessionUserRole = sessionStorage.getItem("selectedUserRole");
    this.userRoleDetails = JSON.parse(sessionUserRole);
    this.roleAssignmentEmail = this.userRoleDetails.user.roleAssignmentEmail;
    this.operationKey = this.userRoleDetails.user.operation === "1" ? 'assign' : 'revoke';
    this.translate.stream(`bss.admin.confirmReq.${this.operationKey}`).subscribe(res => this.operationDescription = res);
    
    //console.log(this.userRoleDetails);

  }

  ngAfterViewInit() {
    this.progressService.setDialog(this.progressDialogElementRef.nativeElement);
  }

  onBack() {
    this.router.navigate(['secure/paadmin/roleMemship']);
  }

  onConfirm() {
    
    this.progressService.open();
    this.userRoleDetails.role.sendNotification = (this.emailChecked)? "0":"1";
    this.restSub = this.rest.updateUserRole(this.userRoleDetails).subscribe(response => {
      if (response.result > 0) {
        this.appError = true;
        this.appErrorMessage = this.appErrorPrefix + "." + response.error_code;
      } else {
        this.appError = false;
        const sucType = (this.userRoleDetails.user.operation === "1") ? 'sa' : 'sr'; 
        const sendEmailType = (this.roleAssignmentEmail === 0||this.userRoleDetails.role.sendNotification === "0")? 'nSd':'sd';
        this.router.navigate(['secure/paadmin/roleMemship'], { queryParams: {suc: sucType,sendE: sendEmailType}});
        //this.router.navigate(['secure/paadmin/requestComplete/success']);
      }
    }, (error) => {
      this.processError(error);
    },
      () => {
        this.progressService.close();
        
      });
    
    
  }

  // onCancel() {
  //   sessionStorage.removeItem("searchUserRole");
  //   this.router.navigate(['secure/paadmin/role/search']);
  // }

  onNewSearch():void {
    this.newSearch();
  }

  ngOnDestroy() {
    if (this.restSub) {
      this.restSub.unsubscribe();
    }
  }

}
